import { render, staticRenderFns } from "./Anmeldung.vue?vue&type=template&id=53205fac&"
import script from "./Anmeldung.vue?vue&type=script&lang=js&"
export * from "./Anmeldung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports